// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import WeVue from "we-vue";
import wx from "weixin-js-sdk";
import VueResource from "vue-resource"; //http

Vue.use(VueResource);


import common from "./js/common";
Vue.use(common); //将全局函数当做插件来进行注册

import global from "./components/global/global";
Vue.prototype.GLOBAL = global; //全局变量

import directive from './js/directive'
Vue.use(directive) //注册指令

import filter from './js/filter'
Vue.use(filter) //注册自定义过滤器

import store from './js/store' //vuex
Vue.prototype.rootglobal = store

import mainservice from './js/mainservice' //全局函数
Vue.use(mainservice)

import axios from 'axios'  //导入axios
//将axios挂载到原型上
Vue.prototype.$axios = axios;
//axios.defaults.baseURL = '/ws'


import "we-vue/lib/style.css";
import "../src/assets/css/style.css";
import "../src/assets/css/font/iconfont.css";

import VueScroller from 'vue-scroller'
Vue.use(VueScroller)

Vue.config.productionTip = false;
Vue.use(WeVue);


import VueLazyLoad from 'vue-lazyload' //图片懒加载 必须放在weVue后面
Vue.use(VueLazyLoad, {
    preLoad: 1.3,
    //loading: require('@/assets/img/svg-loader/three-dots.svg'),
    error: require('@/assets/img/default-img.png'),
    attempt: 1,
    throttleWait: 200
});
/* eslint-disable no-new */

//请求发送拦截器
Vue.http.interceptors.push(function(request, next) {
    // ...
    // 请求发送前的处理逻辑
    // ...
    // if(request.url.indexOf("api/tborder/getfromshorturl")<1){
    //   var borwser = this.GLOBAL.borwser;
    //   if(borwser!='wechat'){
    //     this.$router.push("/page/browserprompt")
    //   }
    // }

    var token = localStorage.getItem("token");
    if (token != "" && token != null && request.url.indexOf("/api/") > 0) {
        token = "token=" + token.substring(1, token.length - 1);
        if (request.url.indexOf("?") > 0) {
            token = "&" + token;
        } else {
            token = "?" + token;
        }
        request.url = request.url + token;
    }

    next(function(response) {
        // ...
        // 请求发送后的处理逻辑
        // ...
        // 根据请求的状态，response参数会返回给successCallback或errorCallback
        var rep = JSON.parse(response.bodyText);
        if (rep.Message == "索引超出了数组界限。") {
            localStorage.removeItem("token");
        }
        if (rep.Message == "Token失效或已过期") {
            localStorage.removeItem("token");
            var returnurl = undefined;
            if (location.hash != undefined && location.hash != null && location.hash.length > 0) {
                returnurl = location.hash.substr(1);
            }
            console.log(response);//
            if(true)//(window.__wxjs_environment != 'miniprogram'||window.__wxjs_environment == 'miniprogram'&&location.hash.indexOf("disid=")>0)
            {
                window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.GLOBAL.appid + "&redirect_uri=" + this.GLOBAL.redirect_uri + "%23%2Faccount%2Fgetroleandlogin%3Fjumpurl%3D" + encodeURIComponent(returnurl) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
            }
            else
            if(localStorage.getItem("token")==null)
            {
                this.$http
                .get(this.GLOBAL.BASE_URL + "api/login/gettemptoken")
                .then(function(d) {
                    var rep = JSON.parse(d.bodyText);
                    if (rep.Success) {
                    this.loginType = rep.Data.LoginType;
                    if (rep.Data.Token.length > 0) {
                        localStorage.setItem("token", JSON.stringify(rep.Data.Token));
                        localStorage.setItem("loginType", this.loginType);
                        localStorage.setItem("showFun", false);
                        
                        
                        var promise = this.$http.get(this.GLOBAL.BASE_URL + "api/getdict");
                        promise.then(function(d) {
                            var rep = JSON.parse(d.bodyText);
                            if (rep.Success) {
                            localStorage.setItem("cachedict", JSON.stringify(rep.Data));
                            } else {
                            Toast.fail(rep.Message);
                            }
                        });
                        window.location.reload();
                    }
                    } else {
                    Toast.fail(rep.Message);
                    }
                });
            }
            //this.$router.push("/account/getroleandlogin");

            // var loginType = localStorage.getItem("loginType");
            // if (loginType == "4") {
            //   this.$router.push("/account/login?type=dis&returnurl=" + encodeURIComponent(returnurl));
            // } else {
            //   this.$router.push("/account/login?returnurl=" + encodeURIComponent(returnurl));
            // }
            return;
        }



        return response;
    });
});
//import * as gl from "./js/getlocation";
//Vue.use(gl); //将全局函数当做插件来进行注册
function getDistrictForMain(latitude, longitude,productid,Vuehttp,globalBASE_URL) {
    let that=Vuehttp;
    let bgurl = globalBASE_URL;
    axios.get('/ws/geocoder/v1/?location='+latitude+','+longitude+'&key=OMTBZ-DXYCX-O3H4O-ZZX2A-YHECK-OXFTQ')
        .then(res => {
          console.log(res)
            var address =res.data.result.address;
            var lat =latitude;
            var lng = longitude;
            var scource = (window.__wxjs_environment == 'miniprogram'?1:0);
            //let that = this;
            that
            .get(bgurl + "api/tbrollcode/wirterecord", {
                params: {
                url: location.href,
                productGuid:productid,
                disid:localStorage.getItem("disid"),
                address:address,
                latitude:lat,
                longitude:lng,
                scource:scource
                }
            })
            .then(function(d) {
                console.log(d);
            });
        })
        .catch(e => {
          console.log(e);
        });
  }

//拦截器 权限拦截
router.beforeEach((to, from, next) => {
    let productid = "0000000000000000000";
    //首页和产品详情页开启分享，其他页面关闭分享
    //alert(to.path);
    if (to.path.indexOf("home") > -1 || to.path.indexOf("productdetail") > -1) {
        // Vue.http
        //     .get("http://test.nongjiaapi.zhoumochuyou.cn/api/tbproduct/getwxinfo", {
        //         params: {
        //             url: location.href.split("#")[0]
        //         }
        //     })
        //     .then(function(d) {
        //         var rep = JSON.parse(d.bodyText);
        //         if (rep.Success) {
        //             wx.config({
        //                 debug: false, // 开启调试模式,
        //                 appId: rep.Data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
        //                 timestamp: rep.Data.timpstamp, // 必填，生成签名的时间戳
        //                 nonceStr: rep.Data.nonceStr, // 必填，生成签名的随机串
        //                 signature: rep.Data.sign, // 必填，签名，见附录1
        //                 jsApiList: ["showMenuItems"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        //             });
        //             wx.ready(function() {
        //                 wx.showMenuItems({
        //                     menuList: [
        //                         "menuItem:share:appMessage",
        //                         "menuItem:share:timeline",
        //                         "menuItem:share:qq",
        //                         "menuItem:share:weiboApp",
        //                         "menuItem:favorite",
        //                         "menuItem:share:QZone"
        //                     ], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
        //                     success: function() {
        //                         //alert("开启分享成功");
        //                     }
        //                 });
        //                 wx.error(function(err) {
        //                     //alert("开启分享失败：" + JSON.stringify(err));
        //                 });
        //             });
        //         } else {
        //             Toast.fail(rep.Message);
        //         }
        //     });
        Vue.http
            .get(global.BASE_URL + "api/tbproduct/getwxinfo", {
                params: {
                    url: location.href.split("#")[0]
                }
            })
            .then(function(d) {
                var rep = JSON.parse(d.bodyText);
                if (rep.Success) {
                    wx.config({
                        debug: false, // 开启调试模式,
                        appId: rep.Data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: rep.Data.timpstamp, // 必填，生成签名的时间戳
                        nonceStr: rep.Data.nonceStr, // 必填，生成签名的随机串
                        signature: rep.Data.sign, // 必填，签名，见附录1
                        jsApiList: ["getLocation"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });
                    setTimeout(function() {
                        wx.ready(function() {
                            wx.error(function(err) {
                                //alert("禁止分享失败：" + JSON.stringify(err));
                            });
                            if(to.path.indexOf("productdetail") > -1){
                                productid=location.hash.split("id=")[1].substr(0,19);
                            }
                            wx.getLocation({
                                type:"gcj02",
                                success: function (res) {
                                  //_this.getDistrict(res.latitude, res.longitude)
                                  console.log("纬度："+res.latitude,"经度"+ res.longitude)
                                  //alert("纬度："+res.latitude,"经度"+ res.longitude);
                                  getDistrictForMain(res.latitude,res.longitude,productid,Vue.http,global.BASE_URL);
                                },
                                cancel: function (res) {
                                  // this.InitProduct();
                                  // this.InitNewProduct();
                                  getDistrictForMain(0,0,productid,Vue.http,global.BASE_URL);
                                },
                                error: function (res) {
                                  // this.InitProduct();
                                  // this.InitNewProduct();
                                  getDistrictForMain(0,0,productid,Vue.http,global.BASE_URL);
                                }
                              })
                        });
                    }, 100);

                } else {
                    Toast.fail(rep.Message);
                }
            });
    } else {
        Vue.http
            .get(global.BASE_URL + "api/tbproduct/getwxinfo", {
                params: {
                    url: location.href.split("#")[0]
                }
            })
            .then(function(d) {
                var rep = JSON.parse(d.bodyText);
                if (rep.Success) {
                    wx.config({
                        debug: false, // 开启调试模式,
                        appId: rep.Data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
                        timestamp: rep.Data.timpstamp, // 必填，生成签名的时间戳
                        nonceStr: rep.Data.nonceStr, // 必填，生成签名的随机串
                        signature: rep.Data.sign, // 必填，签名，见附录1
                        jsApiList: ["hideMenuItems","getLocation"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });
                    setTimeout(function() {
                        wx.ready(function() {
                            wx.hideMenuItems({
                                menuList: [
                                    "menuItem:share:appMessage",
                                    "menuItem:share:timeline",
                                    "menuItem:share:qq",
                                    "menuItem:share:weiboApp",
                                    "menuItem:favorite",
                                    "menuItem:share:QZone"
                                ], // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
                                success: function() {
                                    //alert("禁止分享成功");
                                }
                            });
                            wx.error(function(err) {
                                //alert("禁止分享失败：" + JSON.stringify(err));
                            });
                            wx.getLocation({
                                type:"gcj02",
                                success: function (res) {
                                  //_this.getDistrict(res.latitude, res.longitude)
                                  console.log("纬度："+res.latitude,"经度"+ res.longitude)
                                  //alert("纬度："+res.latitude,"经度"+ res.longitude);
                                  getDistrictForMain(res.latitude,res.longitude,productid,Vue.http,global.BASE_URL);
                                },
                                cancel: function (res) {
                                  // this.InitProduct();
                                  // this.InitNewProduct();
                                  getDistrictForMain(0,0,productid,Vue.http,global.BASE_URL);
                                },
                                error: function (res) {
                                  // this.InitProduct();
                                  // this.InitNewProduct();
                                  getDistrictForMain(0,0,productid,Vue.http,global.BASE_URL);
                                }
                              })
                        });
                    }, 100);

                } else {
                    Toast.fail(rep.Message);
                }
            });
    }

    var token = localStorage.getItem("token");
    if (token == "" || token == null) {
        next();
    } else {
        next();
    }
});


var _hmt = _hmt || [];
(function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?3dd538a0683b61a902519adde8d202a2";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();





new Vue({
    el: "#app",
    router,
    store,
    components: {
        App
    },
    template: "<App/>"
});


// WEBPACK FOOTER //
// ./src/main.js